export const EDIT_SUCCESS = 'Фотография обновлена';
export const EDIT_ERROR = 'Не удалось обновить фотографию';
